import airConnectLogo from "@/assets/images/logo/air_connect_logo_primary_login.svg";
import airDesignLogo from "@/assets/images/logo/air_design_logo_primary_login.svg";
import { Head } from "@/components/atoms/Head";

import { AuthenticatorWrapper } from "../components/AmplifyAuthenticator";

export const SignIn = () => {
  return (
    <>
      <Head title="AIR Design" />

      <div className="grid h-dvh grid-cols-2">
        <div className="grid place-content-center bg-primary-50 px-6">
          <div className="flex flex-col items-center gap-4">
            <img
              src={airDesignLogo}
              alt="AIR Design"
              width={200}
              height={32}
              className="h-8 w-auto max-w-full"
            />
            <div className="h-px w-full bg-primary-300" aria-hidden="true" />
            <img
              src={airConnectLogo}
              alt="AIR Connect"
              width={229}
              height={32}
              className="mt-1.5 h-8 w-auto max-w-full"
            />
          </div>
        </div>
        <div className="grid place-content-center">
          <AuthenticatorWrapper />
        </div>
      </div>
    </>
  );
};
